"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "staticInfoContext", {
  enumerable: true,
  get: function get() {
    return _staticInfoContext["default"];
  }
});
exports.useStaticInfo = void 0;

var _react = require("react");

var _staticInfoContext = _interopRequireDefault(require("../context/staticInfoContext"));

var useStaticInfo = function useStaticInfo() {
  return (0, _react.useContext)(_staticInfoContext["default"]);
};

exports.useStaticInfo = useStaticInfo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2hvb2tzL3VzZVN0YXRpY0luZm8uanMiXSwibmFtZXMiOlsidXNlU3RhdGljSW5mbyIsInN0YXRpY0luZm9Db250ZXh0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFJTyxJQUFNQSxhQUFhLEdBQUcsU0FBaEJBLGFBQWdCO0FBQUEsU0FBTSx1QkFBV0MsNkJBQVgsQ0FBTjtBQUFBLENBQXRCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0J1xyXG5pbXBvcnQgc3RhdGljSW5mb0NvbnRleHQgZnJvbSAnLi4vY29udGV4dC9zdGF0aWNJbmZvQ29udGV4dCdcclxuXHJcbmV4cG9ydCB7IHN0YXRpY0luZm9Db250ZXh0IH1cclxuXHJcbmV4cG9ydCBjb25zdCB1c2VTdGF0aWNJbmZvID0gKCkgPT4gdXNlQ29udGV4dChzdGF0aWNJbmZvQ29udGV4dClcclxuIl19